import React from 'react';
import PropTypes from 'prop-types';

import { doctorProfilePropType } from '../../propTypes/index';
import { contains } from '../DesktopView/DesktopAppointments/filterFunctions';
import styles from './notFound.module.css';

const NotFound = ({ doctors, searchTerm, filter }) => {
  let str;
  if (doctors.length <= 0) {
    str = filter;
  } else if (searchTerm) {
    if (!contains(doctors[0].Name, searchTerm)) {
      str = searchTerm;
    } else if (filter && !contains(searchTerm, filter) && doctors.length <= 1) {
      str = filter;
    }
  }
  return str ? (
    <div className={styles.container}>
      <div>
        Whoops, we can&#39;t find any search results for: <span>{str}</span>
      </div>
    </div>
  ) : null;
};

NotFound.propTypes = {
  doctors: PropTypes.arrayOf(doctorProfilePropType).isRequired,
  searchTerm: PropTypes.string,
  filter: PropTypes.string,
};

export default NotFound;
